<template>
    <div class="background-supplement-no-title-layout" v-loading="loading">
        <div class="layout-content">
            <div class="purchase-content" v-if="classPackages && classPackages.length">
                <ul>
                    <li :class="item.discountStart > 0 && item.discountCountdown > 0 ? 'li-img1' : 'li-img2'" v-for="(item, index) in classPackages" :key="index" @click="lookDetails(item)">
                        <span v-if="item.discountStart > 0 && item.discountCountdown > 0" class="consultant">优惠倒计时{{ item.discountCountdown }}天</span>
                        <div class="period-package">
                            <span class="period-amount">{{ item.name }}</span>
                        </div>
                        <!-- 标准课时包 -->
                        <div v-if="item.type === 'scp'">
                            <p class="detail-package">适合年级：{{ item.packages[0].grade }}</p>
                            <p class="detail-package">课时等级：{{ item.classPackageLevel }}</p>
                            <!-- <p class="detail-package">学习频率：每周{{ item.packages[0].frequency }}课时 学习{{ item.packages[0].duration }}个月</p> -->
                            <p class="detail-package">课时数量：{{ item.classPackageNum }}课时 <span v-if="item.gift && item.classPackageLevel.indexOf(standardClassPackageLevel[item.gift.level]) > -1">另赠送{{ item.gift.period }}课时</span></p>
                            <p class="detail-package">服务内容：{{ item.classPackageService }}</p>
                        </div>
                        <!-- 单个规划课时包 -->
                        <div v-if="item.type === 'tcp' && item.packages.length === 1">
                            <p class="detail-package">基础信息：{{ item.packages[0].subject }} {{ item.packages[0].grade }} {{ item.packages[0].semester }}</p>
                            <p class="detail-package">课时等级：{{ item.classPackageLevel }}</p>
                            <!-- <p class="detail-package">学习频率：每周{{ item.packages[0].frequency }}课时 学习{{ item.packages[0].duration }}个月</p> -->
                            <p class="detail-package">课时数量：{{ item.classPackageNum }}课时 <span v-if="item.gift && item.classPackageLevel.indexOf(standardClassPackageLevel[item.gift.level]) > -1">另赠送{{ item.gift.period }}课时</span></p>
                            <p class="detail-package">服务内容：{{ item.classPackageService }}</p>
                        </div>
                        <!-- 组合规划课时包 -->
                        <div v-if="item.type === 'tcp' && item.packages.length > 1">
                            <p class="detail-package">内含课时包：{{ item.packages.length || 0 }}个</p>
                            <p class="detail-package">课时等级：{{ item.classPackageLevel }}</p>
                            <p class="detail-package">课时数量：{{ item.classPackageNum }}课时 <span v-if="item.gift && item.classPackageLevel.indexOf(standardClassPackageLevel[item.gift.level]) > -1">另赠送{{ item.gift.period }}课时</span></p>
                        </div>
                        <div class="period-money">
                        <p class="money">
                            <span class="final-price">¥{{ item.finalFeeStr }}</span>
                            <span class="original-price" v-if="item.discountCountdown > 0 && !item.gift">¥{{ item.allFeeStr }}</span>
                        </p>
                        <p class="button" @click="lookDetails(item)">立即查看</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-else>
                <div class="no-purchase">
                <img src="../../../assets/images/record/history_icon_curriculum.png" alt="">
                <p>
                    <span class="no-page">您还没有可购买课时包!</span><br/>
                    <span class="number">如想购买好分数辅导相关课程<br/>请联系好分数客服 4008180190</span>
                </p>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import moment from 'moment';
import Enums from '../../../constants/enum.js';
import Numeral from 'numeral';

export default {
    data() {
        return {
            classPackages: [],
            loading: false,
            standardClassPackageLevel: Enums.StandardClassPackageLevel
        };
    },
    beforeMount() {
        this.getPackagePlan();
    },
    methods: {
        // 获取课时包信息
        getPackagePlan() {
            this.loading = true;
            this.$http
                .get('/v3/package-plans/list')
                .then(resp => this.$checkResp(resp, {}))
                .then(data => {
                    data.list.forEach(item => {
                        item.classPackageLevel = ''; // 课时等级
                        item.classPackageNum = 0; // 课时数量
                        item.classPackageService = ''; // 服务内容
                        const payment = item.payments && item.payments.find(v => v.method === 'alipaywechat');
                        if (payment) {
                            item.discountMoney = payment.discountMoney;
                            item.gift = payment.gift;
                            item.totalPrice = payment.finalMoney + payment.discountMoney;
                        }
                        if (item.packages.length > 1) {
                            let arr = [];
                            item.packages.forEach(it => {
                                arr.push(...it.periods);
                            });
                            item.classPackageLevel = Enums.StandardClassPackageLevel[arr[0].level];
                            arr.forEach(it => {
                                item.classPackageNum += it.period;
                            });
                        } else {
                            if (item.packages[0].periods.length > 1) {
                                item.packages[0].periods.forEach((it, ix) => {
                                    item.classPackageLevel += `${ix ? '/' : ''}${Enums.StandardClassPackageLevel[it.level]}${it.period}课时`;
                                    item.classPackageNum += it.period;
                                });
                            } else {
                                item.classPackageLevel = Enums.StandardClassPackageLevel[item.packages[0].periods[0].level];
                                item.classPackageNum = item.packages[0].periods[0].period;
                            }
                            item.packages[0].services.forEach((it, ix) => {
                                if (ix < 2) {
                                    item.classPackageService += it.name + ' ';
                                }
                            });
                        }
                        item.discountCountdown = Math.ceil(moment(item.effectiveTo).diff(moment(), 'days', true)); // 倒计时
                        item.discountStart = Math.ceil(moment().diff(moment(item.effectiveFrom), 'days', true)); // 优惠是否已开始
                        item.allFeeStr = item.totalPrice > 0 ? Numeral(item.totalPrice / 100).format('0.00') : 0.00; // 原价
                        item.finalFeeStr = item.totalPrice - (item.discountMoney || 0) > 0 ? Numeral((item.totalPrice - (item.discountMoney || 0)) / 100).format('0.00') : 0.00; // 售价
                    });
                    this.classPackages = data.list;
                }).catch(() => {
                    this.classPackages = [];
                }).finally(() => {
                    this.loading = false;
                });
        },
        // 查看详情
        lookDetails(item) {
            if (item.packages.length > 1) {
                this.$router.push({
                    name: 'packageList@record',
                    query: {
                        planId: item.planId
                    }
                });
            } else {
                this.$router.push({
                    name: 'detail@package',
                    query: {
                        packageId: item.packages[0].id,
                        planId: item.planId,
                        discountId: item.discountId
                    }
                });
            }
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.layout-content1 {
    padding: 30px;
}

.purchase-content {
    ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .li-img1 {
            background: url(../../../assets/images/record/purchase_img_card1.png) no-repeat center;
            width: 432px;
            height: 255px;
            background-size: 100% 100%;
        }

        .li-img2 {
            background: url(../../../assets/images/record/purchase_img_card2.png) no-repeat center;
            width: 440px;
            height: 255px;
            background-size: 100% 100%;
        }

        li {
            position: relative;
            display: inline-block;
            padding: 34px 30px 40px;
            transition: all 0.5s;
            position: relative;
            margin-bottom: 20px;
            cursor: pointer;

            .period-package {
                font-family: PingFangSC-Medium;
                color: #333;
                margin-bottom: 20px;

                .period-amount {
                    display: inline-block;
                    font-size: 20px;
                    margin-right: 20px;
                    font-weight: 700;
                    line-height: 20px;
                }
            }

            .detail-package {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #666;
                letter-spacing: 0;
                margin-bottom: 10px;
            }

            .period-money {
                width: 100%;
                letter-spacing: 0;
                height: 35px;
                position: absolute;
                left: 0;
                bottom: 30px;
                padding: 30px;

                .money {
                    float: left;
                    line-height: 32px;

                    .final-price {
                        font-family: PingFangSC-Medium;
                        font-size: 20px;
                        color: #f4664b;
                        margin-right: 7px;
                    }

                    .original-price {
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #999;
                        letter-spacing: 0;
                        text-decoration: line-through;
                    }
                }

                .button {
                    background-color: rgba(0, 0, 0, 0.05);
                    display: inline-block;
                    float: right;
                    padding: 10px 16px;
                    background-image: linear-gradient(-44deg, #ff5344 0%, #ff8362 100%);
                    border-radius: 16px;
                    box-shadow: 0 4px 10px 0 rgba(244, 76, 75, 0.43);
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #fff;
                    letter-spacing: 0;
                    cursor: pointer;
                }
            }

            .consultant {
                position: absolute;
                top: 4px;
                right: 4px;
                font-size: 12px;
                color: #fff;
                width: 88px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .color2 {
                color: #fff;
            }

            .color1 {
                color: #999;
            }
        }

        li:hover {
            transform: translateY(-4px);
            transition: all 0.5s;
        }
    }
}

.no-purchase {
    width: 200px;
    margin: 0 auto;
    text-align: center;
    margin-top: 18%;

    img {
        width: 170px;
        height: 170px;
    }

    p {
        .no-page {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #999;
            text-align: center;
            margin-bottom: 10px;
            display: inline-block;
        }

        .number {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #ccc;
            text-align: center;
            line-height: 17px;
            display: inline-block;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/views/index/components/RecordPurchase.vue